(function (angular) {
    'use strict';

    angular.module('app')
        .service('Helpers', helpers);

    helpers.$inject = [
        'modalService',
        '$httpParamSerializer',
        '$location'
    ];

    function helpers(
        modalService,
        $httpParamSerializer,
        $location
    ) {
        /**
         * Replaces html characters to make html content safe for printing to the dom
         * @param  {string} html - html content
         * @return {string}      - escaped text
         */
        function escapeHtml(html) {
            var entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                '\'': '&#39;',
                '/': '&#x2F;'
            };

            return String(html).replace(/[&<>"'\/]/g, function (s) {
                return entityMap[s];
            });
        }

        /**
         * Shows a yes/cancel confirmation dialog, returning the boolean value back to the parent controller
         * @param  {string} message - message to show, i.e. "Are you sure you want to [message]"
         * @return {object}         - modalService object containing result.then()
         */
        function confirmDialog(message) {
            return modalService.open({
                templateUrl: 'modals/confirm.html',
                controller: 'confirmController',
                controllerAs: 'vm',
                windowClass: 'confirm',
                resolve: {
                    message: function () {
                        return message;
                    }
                }
            });
        }

        /**
         * Updates the browser URL using html5 pushstate so that it doesn't cause a page refresh
         * @param  {object} params - URL parameters
         * @param  {function} callback - Called after pushstate
         * @param  {function} fallback - Called if pushstate not available
         * @return {void}
         */
        function pushState(params, callback, fallback) {
            if (history.pushState) {
                var locationSplit = $location.$$absUrl.split('/'),
                    locationNoHost = '/' + locationSplit.splice(3, 999).join('/'),
                    newUrl = locationNoHost + '?' + $httpParamSerializer(params);
                $location.path(newUrl);
                callback();
            } else {
                fallback();
            }
        }

        /**
         * Extracts items from an object by key. Mimics lodash _.get function
         * @param  {object} object
         * @param  {string} keys
         * @param  {any} defaultVal
         * @return {any}
         */
        function extractObj(object, keys, defaultVal) {
            keys = Array.isArray(keys) ? keys : keys.replace(/(\[(\d)\])/g, '.$2').split('.');
            object = object[keys[0]];

            if (object && keys.length > 1) {
                return this.extractObj(object, keys.slice(1), defaultVal);
            }

            return object === undefined ? defaultVal : object;
        }

        return {
            escapeHtml: escapeHtml,
            confirmDialog: confirmDialog,
            pushState: pushState,
            extractObj: extractObj,
            isoFormat: 'Y-MM-DD HH:mm:ss',
        };
    }

}(angular));
